export default __webpack_public_path__ + "static/media/genealoviz-icon.e2b94c7f.svg";